import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { LoaderService } from '../components/loader/loader.service';
import { CustomHttpParams } from '../services/api.service';
import { ToastService } from '@shared/modules/toast/services/toast.service';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  callCount = 0;
  private readonly baseURLConfig: any;
  private readonly authConfig: any;

  constructor(
    public loaderService: LoaderService,
    private toastService: ToastService,
    private runTimeConfigService: RunTimeConfigService,
    private oauthService: OAuthService
  ) {
    this.baseURLConfig = this.runTimeConfigService.getConfig('baseURLConfig');
    this.authConfig = this.runTimeConfigService.getConfig('authConfig');
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let skipLoader: boolean;
    if (req.params instanceof CustomHttpParams) {
      if (req.params.customParams && req.params.customParams.hideLoader) {
        skipLoader = true;
      }
    }

    if (req.url.indexOf('?ping') > -1) {
      skipLoader = true;
    }

    setTimeout(() => {
      if (!skipLoader) {
        this.callCount++;
        this.loaderService.show();
      }
    });

    // console.info(req, '<<< [Inteceptor: Request]');

    return next
      .handle(req)
      .pipe(
        finalize(() => {
          setTimeout(() => {
            if (!skipLoader) {
              this.callCount--;
              if (this.callCount === 0) {
                this.loaderService.hide();
              }
            }
          });
        })
      )
      .pipe(
        tap((ev: HttpEvent<any>) => {
          // if (ev instanceof HttpResponse) {
          //   console.info(ev, '<<< [Inteceptor: Response]');
          // }
        }),
        catchError(response => {
          if (response instanceof HttpErrorResponse) {
            // todo: Create and move logic to exception service
            let skipErrorToast: boolean;
            if (req.params instanceof CustomHttpParams) {
              if (req.params.customParams) {
                if (
                  req.params.customParams.skipInterceptorErrorForCodes &&
                  req.params.customParams.skipInterceptorErrorForCodes.indexOf(response.status) > -1
                ) {
                  skipErrorToast = true;
                }
              }
            }

            if (this.authConfig.authMechanism === 'oauth2-oidc') {
              // bypass oauth errors and handle them individually in callback events
              if (this.oauthService.tokenEndpoint && response.url === this.oauthService.tokenEndpoint) {
                skipErrorToast = true;
              }
            }
            if (req.url.indexOf('?ping') > -1) {
              skipErrorToast = true;
            }

            if (!skipErrorToast) {
              console.info(response, '<<< [Interceptor: Error]');
            }

            if (
              (response.status === 401 || response.status === 403) &&
              !skipErrorToast &&
              response.url.indexOf(this.baseURLConfig.APIM.baseURL) === -1
            ) {
              console.error('Error connecting to ' + req.url);
              this.toastService.showToast(
                'lang.appShared.interceptors.loaderInterceptor.toastMessage.acessDeniedYouAreUnauthorized',
                'toastError',
                {
                  clearToasts: true
                }
              );
            } else if (response.status === 404 && !skipErrorToast) {
              console.error('API not found for ' + req.url);
              this.toastService.showToast(
                'lang.appShared.interceptors.loaderInterceptor.toastMessage.requestURLIsCurrentlyUnreachable',
                'toastError',
                { clearToasts: true }
              );
            } else if (!skipErrorToast) {
              this.toastService.showToast(
                'lang.commonComponents.commonWords.commonToasterMessage.weAreCurrentlyFacingTechnicalError',
                'toastError',
                { clearToasts: true }
              );
            }
          }

          return throwError(response);
        })
      );
  }
}
